import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FileUploadModule } from "primeng/fileupload";
import { FileUploaderComponent } from "ng/src/app/files/file-uploader/file-uploader.component";
import { TableModule } from "primeng/table";
import { DividerModule } from "primeng/divider";
import { DragDropModule } from "primeng/dragdrop";
import { FormsModule } from "@angular/forms";
import { FileDetailsComponent } from "ng/src/app/files/file-details/file-details.component";
import { FilesComponent } from "ng/src/app/files/files/files.component";
import { SharedModule } from "ng/src/app/shared/shared.module";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileDetailListingComponent } from "ng/src/app/files/file-detail-listing/file-detail-listing.component";
import { OverlayPanelModule } from "primeng/overlaypanel";

@NgModule({
	declarations: [
		FileUploaderComponent,
		FileDetailsComponent,
		FilesComponent,
		FileDetailListingComponent
	],
	exports: [
		FileUploaderComponent,
		FileDetailsComponent,
		FilesComponent,
		FileDetailListingComponent
	],
	imports: [
		CommonModule,
		FileUploadModule,
		TableModule,
		DividerModule,
		DragDropModule,
		FormsModule,
		SharedModule,
		CardModule,
		ConfirmDialogModule,
		OverlayPanelModule
	]
})
export class FilesModule {}